import PropTypes from 'prop-types';
import { useState, useEffect, useRef } from 'react';
import useActOnExternalClick from '../../hooks/useActOnExternalClick';
import { handleFilterInteraction } from '../../utils/analytics';

function SearchTypeMenu(
	{
		items = [],
		onChange = () => {},
		initialSelected = {},
	},
) {
	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState(initialSelected.name ? initialSelected : items[0]);
	const searchTypeMenu = useRef(null);

	const handleChange = (item) => {
		setOpen(false);
		setSelected(item);
		onChange(item);
		if (item) {
			handleFilterInteraction('filterSearch', item.value ?? 'all-content');
		}
	};

	const getSelectedItem = (current) => {
		if (current.label) {
			return current;
		}

		return items.find((item) => item.type === current.type && item.value === current.value);
	};

	SearchTypeMenu.handleClickOutside = () => setOpen(false);

	useEffect(() => {
		setSelected(initialSelected.name ? initialSelected : items[0]);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialSelected]);

	useActOnExternalClick(searchTypeMenu, open, SearchTypeMenu.handleClickOutside);

	return (
		<div className="search-type-menu" ref={searchTypeMenu}>
			<button
				aria-haspopup="true"
				aria-expanded={open}
				aria-controls={open && 'search-type-menu-items'}
				id="search-type-menu"
				onClick={() => setOpen(!open)}
				type="button"
			>
				<strong>SHOW</strong>
				{' '}
				<span>{getSelectedItem(selected).label}</span>
				<span className={`search-type-menu-toggle ${open ? 'up' : 'down'}`} />
			</button>
			{open && (
				<div aria-labelledby="search-type-menu" id="search-type-menu-items" role="menu" tabIndex="0">
					{items.map((item) => {
						const isSelected = item.type === selected.type && item.value === selected.value;
						return (
							<button
								className={isSelected ? 'search-type-active' : ''}
								onClick={() => handleChange(item)}
								role="menuitem"
								tabIndex="-1"
								type="button"
								key={item.label}
							>
								{item.label}
							</button>
						);
					})}
				</div>
			)}
		</div>
	);
}

SearchTypeMenu.propTypes = {
	items: PropTypes.array,
	initialSelected: PropTypes.object,
	onChange: PropTypes.func,
};

export default SearchTypeMenu;
